export { default } from './FreeShippingProgressBar';